import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _MacroProcess } from '../../../../../core/services/dataBean/EntityCatalog';
import { _LoanCurrency } from '../../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const LoanCurrencySelect = ({ idSelector, onChange, label }: Props) => {

    const loanCurrency = useDataBean(_LoanCurrency)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {

        loanCurrency.instance.getLoanCurrencyCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Tipo de Moneda:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDLoanCurrency} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}